import React from 'react';

import DeliveryProgressBanner from '~/src/common/components/DeliveryProgressBanner/DeliveryProgressBanner';
import CommonLayout from '~/src/common/components/Layout/CommonLayout';
import Navigation from '~/src/common/components/Navigation/Navigation/Navigation';
import styles from '~/src/common/theme/classes/_classes.module.scss';

interface Props {
  children: React.ReactElement;
}

const ScreenLayout = ({ children }: Props) => {
  return (
    <CommonLayout>
      <>
        <DeliveryProgressBanner />

        <Navigation source="Homepage" />

        <div className={styles.productsLayoutContainer}>{children}</div>
      </>
    </CommonLayout>
  );
};

export default ScreenLayout;
